// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.options {
  display: flex;
  border: 5px;
  gap: 16px;
}

.FA {
  width: 157px;
  height: 32px;
  padding-left: 24px;
  font-weight: bold;
}

.Select-Supplier {
  width: 130px;
  height: 32px;
}

.date {
  border-radius: 4px;
}
.date .p-inputtext {
  border-radius: 4px;
  height: 28px;
}
.date .p-button.p-button-icon-only {
  height: 28px;
  position: absolute;
  right: 0;
}

.acp .highlight-row {
  background: #eef2ff !important;
  color: #4338ca !important;
}
.acp .highlight-row-planning {
  background: #e6f6e6 !important;
  font-weight: bold;
}
.acp .highlight-row-draft-planning {
  background: #bbfabb !important;
  font-weight: bold;
}
.acp .invertedIcon {
  transform: rotate(180deg);
  transition: transform 0.5s;
  cursor: pointer;
}
.acp .nonInvertedIcon {
  transition: 0.5s;
  cursor: pointer;
}
.acp .infoIcon,
.acp .errorIcon {
  cursor: pointer;
}
.acp .acp-booking-table-dropdown {
  display: flex;
  gap: 16px;
}
.acp .select-FA {
  margin-left: 24px;
  width: 90px;
  height: 32px;
}
.acp .select-supplier {
  width: 130px;
  height: 32px;
}
.acp .content-layout .tabular-view .actions .action-buttons {
  gap: 16px !important;
}
.acp .acp-calendar {
  width: 100px;
}
.acp .acp-calendar .p-inputtext {
  border-radius: 4px;
  height: 32px;
}
.acp .acp-calendar .p-inputtext:hover {
  cursor: pointer;
}
.acp .acp-booking-table {
  margin-bottom: 50px;
}
.acp .acp-booking-table .p-datatable {
  padding: 5px 10px;
}
.acp .acp-booking-table .p-datatable > .p-datatable-wrapper {
  overflow: scroll !important;
  width: 100% !important;
  height: 69.5vh !important;
}
.acp .acp-booking-table .p-datatable > .p-datatable-wrapper table tbody tr td div {
  display: flex;
  justify-content: center;
}
.acp .acp-booking-table .p-datatable > .p-datatable-wrapper table tbody tr.p-rowgroup-header td div {
  display: flex;
  justify-content: start;
}
.acp .acp-booking-table .p-datatable-scrollable-table > .p-datatable-tbody > .p-rowgroup-header {
  z-index: 70;
  position: sticky;
  background: #f2f7fc;
  border-top: 3px solid white;
  color: var(--Primary-color, #003da5);
}
.acp .acp-booking-table .start-date-awaiting {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 10px;
  font-weight: 900;
}
.acp .acp-booking-table .image-info-icon {
  padding-left: 3.5%;
}
.acp .text-massUpdate {
  color: #003da5;
  font-weight: bold;
  padding: 8px 20px 8px 20px;
}
.acp .text-massUpdate:hover {
  color: #003da5;
  background: #f2f7fc !important;
  padding: 8px 20px 8px 20px;
  border-radius: 5px;
}
.acp .acp-actions {
  padding: 8px 12px 0 0px;
}
.acp .acp-actions .action-buttons .dropdown-button-custom.show.dropdown .dropdown-menu.show {
  padding: 0;
}
.acp .acp-actions .action-buttons .dropdown-button-custom.show.dropdown .dropdown-menu.show a.dropdown-item {
  font-size: 12px;
  color: #003da5;
  font-weight: bold;
  padding: 8px 20px;
}
.acp .acp-actions .action-buttons .dropdown-button-custom.show.dropdown .dropdown-menu.show a.dropdown-item.disabled {
  color: #7e8797 !important;
}
.acp .acp-actions .action-buttons .dropdown-button-custom.show.dropdown .dropdown-menu.show a.dropdown-item:hover {
  border-radius: 0 0 0 0;
  background: #f2f7fc !important;
}
.acp .acp-footer {
  padding: 8px 10px 15px 10px !important;
  background: #fafafa !important;
  bottom: 0.5rem !important;
  position: sticky;
  width: 100%;
  margin: 0 auto;
  z-index: 999;
  left: 7.95%;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.acp-dialog {
  width: 55vw !important;
  min-height: 20%;
  max-height: 90%;
  border-radius: 20px;
}
.acp-dialog .p-dialog .p-dialog-header {
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}
.acp-dialog .p-dialog .p-dialog-header-icons {
  padding-bottom: 5px;
}
.acp-dialog .p-dialog-acp {
  color: #003da5;
  font-size: 18px;
  font-weight: 700;
}
.acp-dialog .p-dialog-acp-error {
  color: #c3133f;
  font-size: 1.45rem;
  font-weight: 700;
}
.acp-dialog .p-dialog-content {
  padding: 20px 32px 20px 32px !important;
  border-radius: 0 0 20px 20px;
  overflow-y: hidden;
}

.tooltipACP {
  color: rgb(254, 254, 254);
  border-color: #007bff;
  margin: 23px 0 0 -5.5px;
}
.tooltipACP .tooltip-inner {
  background-color: rgb(254, 254, 254) !important;
  max-width: 381px;
  min-height: 30px;
  border-radius: 2px;
  border: solid 1px rgb(172, 172, 172);
  overflow-y: auto;
  padding: 11px 16px 11px 14px;
  box-shadow: 0px 6px 16px 0px rgba(89, 89, 89, 0.24);
  margin-top: -40px;
}

.toolnameACP {
  color: rgb(89, 89, 89);
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  text-align: left;
  line-height: 13px;
}
.toolnameACP ul {
  padding-left: 13px;
  margin-bottom: 0px;
}

.tooltipACP > .tooltip-arrow {
  top: -8px !important;
}

.tooltipACP > .tooltip-arrow::before {
  border: 1px solid rgb(172, 172, 172);
  width: 12px;
  height: 12px;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  transform: rotate(45deg);
  right: -9px;
  background-color: #fff;
  top: -24px;
}

.navigationButtonWrapper,
.navigationButton {
  width: 100%;
  background: #f2f7fc;
  height: 28px;
  border: 0;
  display: flex;
  align-items: center;
}

.navigationButton {
  width: 76px;
  text-decoration: none;
}

.navigationText {
  margin-bottom: 0;
  color: #595959;
  font-size: 10px;
  font-weight: 500;
  font-family: "Montserrat";
  font-style: normal;
}

.tableHeader {
  color: #595959;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  font-family: "Montserrat";
  font-style: normal;
}

.tableSubHeader {
  color: #595959;
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  font-family: "Montserrat";
}

.dataTableWrapper {
  margin: 24px 7.5% 24px 7.5%;
  border-radius: 4px;
  border: 1px solid #acacac;
  width: 935px;
}
.dataTableWrapper table thead {
  height: 39px !important;
}
.dataTableWrapper tbody tr {
  height: 31px;
}
.dataTableWrapper .p-datatable .p-datatable-tbody > tr > td {
  text-align: center;
  padding: 0;
}
.dataTableWrapper .columnDataText {
  padding: 8px !important;
  border: 1px solid #acacac !important;
}
.dataTableWrapper .negativeValue {
  background: #ffd8d8 !important;
}

.p-datepicker:not(.p-datepicker-inline) .p-datepicker-header,
.p-datepicker table td.p-datepicker-today > span.p-highlight {
  background: #003da5;
}

.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year,
.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month,
.p-datepicker .p-datepicker-header .p-datepicker-prev,
.p-datepicker .p-datepicker-header .p-datepicker-next,
.p-datepicker table td.p-datepicker-today > span.p-highlight {
  color: #ffffff;
  font-family: "Montserrat";
}

.p-datepicker {
  width: 280px !important;
}

.p-datepicker .p-monthpicker .p-monthpicker-month.p-highlight {
  background: #003da5;
  color: #ffffff;
}

.p-datepicker {
  margin-top: 5px;
}

.weekRangeDataWraper {
  display: flex;
  height: 81px;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
}

.weekRangeData {
  flex-direction: row;
  width: 91px;
  height: 19px;
}
.weekRangeData:hover {
  cursor: pointer;
}

.current-date {
  margin-bottom: 0 !important;
}

.dataTableWrapper .tableSubHeader {
  width: 130px !important;
}
.dataTableWrapper .p-datatable .p-datatable-thead > tr > th {
  width: 120px !important;
}

.acp-planning-page {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.acp-planning-page .p-datatable .p-column-header-content:nth-child(1) {
  justify-content: center;
}

.projectSetupParent {
  flex: 1 1;
}

.error-info-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 5%;
}

.headerWrapper {
  padding: 0.1rem 1rem;
  margin-top: 5px;
}

.acp-header .actions {
  margin-right: 5px;
}

.acp-header img.header-icons {
  margin-right: 10px;
}

.breadCrumbParent {
  padding-left: 0px !important;
}

.breadCrumbParent .dropdown-menu.show {
  padding-top: 0px;
  padding-bottom: 0px;
  margin-top: 0px !important;
  border-radius: 5px;
  border: 0.5px solid #b1b2b4 !important;
}

.navigationButtonWrapper {
  padding-left: 2%;
}
.navigationButtonWrapper .navigationButton {
  justify-content: center;
}
.navigationButtonWrapper .rccpText {
  color: #003da5;
}
.navigationButtonWrapper .activeSection {
  color: #003da5;
  font-weight: 500;
  border-bottom: 1px solid var(--Primary-Color, #003da5);
}
.navigationButtonWrapper .activeSection .navigationText {
  color: #003da5;
}

.selection-main {
  position: absolute;
  left: 19%;
  top: 6%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.selection-cont {
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 0.8rem;
}

.selection-cont button {
  background: #efefef;
  border: none;
  padding: 0.5rem;
  border-radius: 0.3rem;
  background: rgb(0, 61, 165) !important;
  color: #fff;
}

.selection-cont i {
  position: relative !important;
  inset: 0 !important;
  margin-right: 6px;
}

.ranges-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.8rem;
}

.ranges-btn button {
  width: 30px;
  background: #efefef;
  border-radius: 4px;
  margin-right: 5px;
  padding: 6px;
  border: none;
  color: #003da5;
}

.capacity-main {
  position: relative;
}

.acp-main .col {
  display: flex;
}

.time-period-btn {
  width: 30px;
  background: rgb(239, 239, 239);
  border-radius: 4px;
  margin-right: 5px;
  padding: 5px;
  color: rgb(0, 61, 165);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.time-period-btn.selected {
  background-color: rgb(0, 61, 165) !important;
  color: #fff !important;
}

.booking-tabs {
  overflow: auto !important;
  padding-bottom: 0px !important;
}

.booking-header {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 8px 12px 0 0px;
  align-items: center;
}

.data-table-checkbox-column div table thead tr th:nth-child(1),
.data-table-checkbox-column div table thead tr td:nth-child(1),
.data-table-checkbox-column div table tbody tr th:nth-child(1),
.data-table-checkbox-column div table tbody tr td:nth-child(1) {
  width: 50px !important;
  min-width: 50px !important;
}
.data-table-checkbox-column div table thead tr th:nth-child(1) div,
.data-table-checkbox-column div table thead tr td:nth-child(1) div,
.data-table-checkbox-column div table tbody tr th:nth-child(1) div,
.data-table-checkbox-column div table tbody tr td:nth-child(1) div {
  justify-content: center;
}

.acpBooking .flex-display {
  display: flex;
}
.acpBooking div table {
  margin-bottom: 80px;
}
.acpBooking div table th.p-filter-column.p-frozen-column:nth-child(1) {
  max-width: 34px !important;
}
.acpBooking div table th.p-filter-column.p-frozen-column:nth-child(1) div.p-column-filter.p-fluid.p-column-filter-row {
  visibility: hidden;
  max-width: 34px !important;
}
.acpBooking div table th.p-filter-column.p-frozen-column:nth-child(1) div.p-column-filter.p-fluid.p-column-filter-row div.p-fluid.p-column-filter-element .p-column-filter.p-inputtext.p-component {
  text-align: center !important;
}
.acpBooking div table th.p-filter-column div.p-column-filter.p-fluid.p-column-filter-row div.p-fluid.p-column-filter-element .p-column-filter.p-inputtext.p-component {
  text-align: center !important;
}
.acpBooking tbody {
  top: 0;
  position: sticky;
}
.acpBooking tbody tr:nth-last-child(2) td {
  border-bottom-width: 1.4px !important;
}
.acpBooking tbody tr.p-rowgroup-header {
  top: 36px;
  z-index: 111 !important;
  position: sticky !important;
  text-align: left !important;
  background: #e1edff !important;
}
.acpBooking tbody tr.p-rowgroup-header td {
  left: 0px;
  border: 0;
  z-index: 2;
  position: sticky;
  text-align: left;
  text-overflow: ellipsis;
}
.acpBooking tbody tr.p-rowgroup-header td:nth-child(1) {
  z-index: 20;
}
.acpBooking tbody tr.p-rowgroup-header td .p-rowgroup-header-name {
  min-width: 85%;
  cursor: pointer;
  min-height: 20px;
  padding-left: 20px;
}
.acpBooking tbody tr.p-rowgroup-header td .p-rowgroup-header-name .group-wrapper {
  bottom: 10px;
  position: relative;
}
.acpBooking tbody tr.p-rowgroup-header td .p-rowgroup-header-name .group-wrapper .group-header {
  padding-left: 5px;
}
.acpBooking tbody tr.p-rowgroup-header td .p-rowgroup-header-name .group-wrapper .group-header span {
  font-size: 14px;
  color: #003da5;
  font-weight: bold;
}
.acpBooking tbody tr.p-rowgroup-header td .p-rowgroup-header-name .group-wrapper .group-header .group-length {
  margin-left: 6px;
}
.acpBooking tbody tr.p-rowgroup-header td .p-rowgroup-header-name .group-wrapper .group-header .p-link {
  margin-left: 4px;
}
.acpBooking tbody tr.p-rowgroup-header td .p-row-toggler.p-link {
  height: 0;
  visibility: hidden !important;
}
.acpBooking tbody tr.p-rowgroup-header:has(.top-5) {
  top: 225px !important;
}
.acpBooking tbody tr.p-rowgroup-header:has(.top-6) {
  top: 275px !important;
}
.acpBooking tbody tr td {
  text-align: center;
}

.text-danger {
  color: red;
}

.summary-table {
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto !important;
}
.summary-table .p-datatable {
  width: 100%;
}
.summary-table th span,
.summary-table td {
  font-size: 12px;
}
.summary-table .negativeValue {
  font-weight: bold;
}

#dashboard div .capacity-main .acp-main {
  min-height: 438px;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper {
  margin-top: 20px;
  margin-bottom: 20px;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table {
  margin-top: 0px;
  margin-bottom: 0px;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table:has(.panel2) {
  margin-top: 0px;
  margin-bottom: 60px;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel1.p-panel.p-component.p-panel-toggleable {
  margin-bottom: 10px;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel1.p-panel.p-component.p-panel-toggleable .p-panel-header {
  color: #003da5;
  background-color: #edf4fa;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel1.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper {
  height: 40vh !important;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel1.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table {
  margin-bottom: 20px;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel1.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table thead tr th.p-filter-column.p-frozen-column:nth-child(1) {
  max-width: 53px !important;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel1.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table thead tr th.p-filter-column.p-frozen-column:nth-child(1) div.p-column-filter.p-fluid.p-column-filter-row {
  visibility: hidden;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel1.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table thead tr th .p-column-header-content:nth-child(1) {
  justify-content: center;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel1.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table thead tr th.p-filter-column div.p-column-filter.p-fluid.p-column-filter-row div.p-fluid.p-column-filter-element .p-column-filter.p-inputtext.p-component {
  text-align: center !important;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel1.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table tbody tr td {
  border-width: 1px 1px 1px 1px;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel1.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table tbody tr.p-datatable-row-expansion td {
  border-width: 0;
  padding: 0rem 0rem;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel2.p-panel.p-component.p-panel-toggleable {
  margin-bottom: 10px;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel2.p-panel.p-component.p-panel-toggleable .p-panel-header {
  color: #003da5;
  background-color: #edf4fa;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel2.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper {
  height: 50.5vh !important;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel2.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table {
  margin-bottom: 40px;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel2.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table thead tr th.p-filter-column.p-frozen-column:nth-child(1) {
  max-width: 40px !important;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel2.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table thead tr th.p-filter-column.p-frozen-column:nth-child(1) div.p-column-filter.p-fluid.p-column-filter-row {
  visibility: hidden;
  max-width: 40px !important;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel2.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table thead tr th.p-filter-column div.p-column-filter.p-fluid.p-column-filter-row div.p-fluid.p-column-filter-element .p-column-filter.p-inputtext.p-component {
  text-align: center !important;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel2.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table tbody tr.p-rowgroup-header {
  top: 39px;
  border-top: 0;
  z-index: 111 !important;
  position: sticky !important;
  text-align: left !important;
  background: #e1edff !important;
  border-left: 1px solid #aba8a8;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel2.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table tbody tr.p-rowgroup-header td {
  left: 0px;
  border: 0;
  z-index: 2;
  width: 41.3%;
  position: sticky;
  text-align: left;
  text-overflow: ellipsis;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel2.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table tbody tr.p-rowgroup-header td:nth-child(1) {
  z-index: 20;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel2.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table tbody tr.p-rowgroup-header td .p-rowgroup-header-name {
  min-width: 85%;
  cursor: pointer;
  min-height: 20px;
  padding-left: 20px;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel2.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table tbody tr.p-rowgroup-header td .p-rowgroup-header-name .group-wrapper {
  bottom: 10px;
  position: relative;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel2.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table tbody tr.p-rowgroup-header td .p-rowgroup-header-name .group-wrapper .group-header {
  padding-left: 5px;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel2.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table tbody tr.p-rowgroup-header td .p-rowgroup-header-name .group-wrapper .group-header span {
  font-size: 14px;
  color: #003da5;
  font-weight: bold;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel2.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table tbody tr.p-rowgroup-header td .p-rowgroup-header-name .group-wrapper .group-header .group-length {
  margin-left: 6px;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel2.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table tbody tr.p-rowgroup-header td .p-rowgroup-header-name .group-wrapper .group-header .p-link {
  margin-left: 4px;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel2.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table tbody tr.p-rowgroup-header td .p-row-toggler.p-link {
  height: 0;
  visibility: hidden !important;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel2.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table tbody tr td {
  border-width: 1px 1px 1px 1px;
}
#dashboard div .capacity-main .acp-main div .dashboard-panel-wrapper .acp-booking-table .panel2.p-panel.p-component.p-panel-toggleable .p-toggleable-content .p-panel-content .acpBooking .p-datatable-wrapper table tbody tr.p-datatable-row-expansion td {
  border-width: 0;
}

.dashboard-container {
  display: flex;
}
.dashboard-container .autocomplete-container {
  margin-left: 20px;
  margin-right: 10px;
}
.dashboard-container .p-autocomplete {
  border: 1px solid #003da5 !important;
}

.clear-search-wrapper {
  position: relative;
}
.clear-search-wrapper .clear-search-btn {
  right: 0;
  bottom: -12px;
  position: absolute;
}

.task-link {
  cursor: pointer;
  color: #0a58ca;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/components/ACP/index.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,WAAA;EACA,SAAA;AADF;;AAIA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AADF;;AAIA;EACE,YAAA;EACA,YAAA;AADF;;AAIA;EACE,kBAAA;AADF;AAGE;EACE,kBAAA;EACA,YAAA;AADJ;AAIE;EACE,YAAA;EACA,kBAAA;EACA,QAAA;AAFJ;;AAUE;EACE,8BAAA;EACA,yBAAA;AAPJ;AAWE;EACE,8BAAA;EACA,iBAAA;AATJ;AAYE;EACE,8BAAA;EACA,iBAAA;AAVJ;AAaE;EACE,yBAAA;EACA,0BAAA;EACA,eAAA;AAXJ;AAcE;EACE,gBAAA;EACA,eAAA;AAZJ;AAeE;;EAEE,eAAA;AAbJ;AAgBE;EACE,aAAA;EACA,SAAA;AAdJ;AAiBE;EACE,iBAAA;EACA,WAAA;EACA,YAAA;AAfJ;AAkBE;EACE,YAAA;EACA,YAAA;AAhBJ;AAoBE;EACE,oBAAA;AAlBJ;AAqBE;EACE,YAAA;AAnBJ;AAqBI;EACE,kBAAA;EACA,YAAA;AAnBN;AAqBM;EACE,eAAA;AAnBR;AAmCE;EACE,mBAAA;AAjCJ;AAmCI;EACE,iBAAA;AAjCN;AAmCI;EACE,2BAAA;EACA,sBAAA;EAGA,yBAAA;AAnCN;AAyCc;EACE,aAAA;EACA,uBAAA;AAvChB;AA8Cc;EACE,aAAA;EACA,sBAAA;AA5ChB;AAsEI;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,oCAAA;AApEN;AAuEI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AArEN;AAyEI;EACE,kBAAA;AAvEN;AA2EE;EACE,cAAA;EACA,iBAAA;EACA,0BAAA;AAzEJ;AA2EI;EACE,cAAA;EACA,8BAAA;EACA,0BAAA;EACA,kBAAA;AAzEN;AA6EE;EACE,uBAAA;AA3EJ;AA+EQ;EACE,UAAA;AA7EV;AA+EU;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AA7EZ;AA+EY;EACE,yBAAA;AA7Ed;AAgFY;EACE,sBAAA;EACA,8BAAA;AA9Ed;AAsFE;EACE,sCAAA;EACA,8BAAA;EAEA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,+BAAA;EACA,gCAAA;AArFJ;;AAyFA;EACE,sBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AAtFF;AAwFE;EACE,4BAAA;EACA,2BAAA;AAtFJ;AAyFE;EACE,mBAAA;AAvFJ;AA0FE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAxFJ;AA2FE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AAzFJ;AA4FE;EACE,uCAAA;EACA,4BAAA;EACA,kBAAA;AA1FJ;;AA8FA;EACE,yBAAA;EACA,qBAAA;EACA,uBAAA;AA3FF;AA6FE;EACE,+CAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,4BAAA;EACA,mDAAA;EACA,iBAAA;AA3FJ;;AA+FA;EACE,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EAEA,iBAAA;AA7FF;AA+FE;EACE,kBAAA;EACA,kBAAA;AA7FJ;;AAiGA;EACE,oBAAA;AA9FF;;AAiGA;EACE,oCAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,wCAAA;EACA,wBAAA;EACA,WAAA;EACA,sBAAA;EACA,UAAA;AA9FF;;AAiGA;;EAEE,WAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AA9FF;;AAiGA;EACE,WAAA;EACA,qBAAA;AA9FF;;AAiGA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AA9FF;;AA2GA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AAxGF;;AA2GA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAxGF;;AA2GA;EACE,2BAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;AAxGF;AA0GE;EACE,uBAAA;AAxGJ;AA2GE;EACE,YAAA;AAzGJ;AA4GE;EACE,kBAAA;EACA,UAAA;AA1GJ;AAiHE;EACE,uBAAA;EACA,oCAAA;AA/GJ;AAkHE;EACE,8BAAA;AAhHJ;;AA0HA;;EAEE,mBAAA;AAvHF;;AA0HA;;;;;EAKE,cAAA;EACA,yBAAA;AAvHF;;AA0HA;EACE,uBAAA;AAvHF;;AA0HA;EACE,mBAAA;EACA,cAAA;AAvHF;;AA0HA;EACE,eAAA;AAvHF;;AA0HA;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AAvHF;;AA0HA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;AAvHF;AAyHE;EACE,eAAA;AAvHJ;;AA2HA;EACE,2BAAA;AAxHF;;AA4HE;EACE,uBAAA;AAzHJ;AA4HE;EACE,uBAAA;AA1HJ;;AA8HA;EAOE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AAjIF;AA0HE;EACE,uBAAA;AAxHJ;;AAiIA;EACE,SAAA;AA9HF;;AAiIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AA9HF;;AAiIA;EACE,oBAAA;EACA,eAAA;AA9HF;;AAgIA;EACI,iBAAA;AA7HJ;;AA+HA;EACI,kBAAA;AA5HJ;;AA8HA;EACI,4BAAA;AA3HJ;;AA6HA;EACE,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,sCAAA;AA1HF;;AA6HA;EACE,gBAAA;AA1HF;AA4HE;EACE,uBAAA;AA1HJ;AA6HE;EACE,cAAA;AA3HJ;AA8HE;EACE,cAAA;EACA,gBAAA;EACA,sDAAA;AA5HJ;AA8HI;EACE,cAAA;AA5HN;;AAkIA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA/HF;;AAkIA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;AA/HF;;AAkIA;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,sCAAA;EACA,WAAA;AA/HF;;AAkIA;EACE,6BAAA;EACA,mBAAA;EACA,iBAAA;AA/HF;;AAkIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AA/HF;;AAkIA;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;AA/HF;;AAkIA;EACE,kBAAA;AA/HF;;AAkIA;EACE,aAAA;AA/HF;;AAkIA;EACE,WAAA;EACA,8BAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA/HF;;AAkIA;EACE,4CAAA;EACA,sBAAA;AA/HF;;AAkIA;EACE,yBAAA;EACA,8BAAA;AA/HF;;AAkIA;EACE,aAAA;EACA,WAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AA/HF;;AAwIU;;;;EAEE,sBAAA;EACA,0BAAA;AAnIZ;AAqIY;;;;EACE,uBAAA;AAhId;;AA0IE;EACE,aAAA;AAvIJ;AA2II;EACE,mBAAA;AAzIN;AAgKQ;EACE,0BAAA;AA9JV;AAgKU;EACE,kBAAA;EACA,0BAAA;AA9JZ;AAiKc;EACE,6BAAA;AA/JhB;AAyKY;EACE,6BAAA;AAvKd;AA+KE;EACE,MAAA;EACA,gBAAA;AA7KJ;AAiLQ;EACE,qCAAA;AA/KV;AAmLM;EACE,SAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;AAjLR;AAmLQ;EACE,SAAA;EACA,SAAA;EACA,UAAA;EAEA,gBAAA;EACA,gBAAA;EACA,uBAAA;AAlLV;AAoLU;EACE,WAAA;AAlLZ;AAqLU;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAnLZ;AAqLY;EACE,YAAA;EACA,kBAAA;AAnLd;AAqLc;EACE,iBAAA;AAnLhB;AAqLgB;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AAnLlB;AAsLgB;EACE,gBAAA;AApLlB;AAuLgB;EACE,gBAAA;AArLlB;AA2LU;EACE,SAAA;EACA,6BAAA;AAzLZ;AA6MQ;EACE,qBAAA;AA3MV;AA8MQ;EACE,qBAAA;AA5MV;AAkNM;EACE,kBAAA;AAhNR;;AAqPA;EACE,UAAA;AAlPF;;AAqPA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAlPF;AAoPE;EACE,WAAA;AAlPJ;AAqPE;;EAEE,eAAA;AAnPJ;AAsPE;EACE,iBAAA;AApPJ;;AA6PM;EACE,iBAAA;AA1PR;AA6PU;EACE,gBAAA;EACA,mBAAA;AA3PZ;AA6PY;EACE,eAAA;EACA,kBAAA;AA3Pd;AA6Pc;EACE,eAAA;EACA,mBAAA;AA3PhB;AA8Pc;EACE,mBAAA;AA5PhB;AA8PgB;EACE,cAAA;EACA,yBAAA;AA5PlB;AAkQsB;EACE,uBAAA;AAhQxB;AAkQwB;EACE,mBAAA;AAhQ1B;AAqQgC;EACE,0BAAA;AAnQlC;AAqQkC;EACE,kBAAA;AAnQpC;AAwQ8B;EACE,uBAAA;AAtQhC;AA4QoC;EACE,6BAAA;AA1QtC;AAoR8B;EACE,6BAAA;AAlRhC;AAsRgC;EACE,eAAA;EACA,kBAAA;AApRlC;AAgSc;EACE,mBAAA;AA9RhB;AAgSgB;EACE,cAAA;EACA,yBAAA;AA9RlB;AAoSsB;EACE,yBAAA;AAlSxB;AAoSwB;EACE,mBAAA;AAlS1B;AAuSgC;EACE,0BAAA;AArSlC;AAuSkC;EACE,kBAAA;EACA,0BAAA;AArSpC;AA6SoC;EACE,6BAAA;AA3StC;AAqT8B;EACE,SAAA;EACA,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;AAnThC;AAqTgC;EACE,SAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AAnTlC;AAqTkC;EACE,WAAA;AAnTpC;AAsTkC;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AApTpC;AAsToC;EACE,YAAA;EACA,kBAAA;AApTtC;AAsTsC;EACE,iBAAA;AApTxC;AAsTwC;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AApT1C;AAuTwC;EACE,gBAAA;AArT1C;AAwTwC;EACE,gBAAA;AAtT1C;AA4TkC;EACE,SAAA;EACA,6BAAA;AA1TpC;AAuV8B;EACE,6BAAA;AArVhC;AAyVgC;EACE,eAAA;AAvVlC;;AA0WA;EACE,aAAA;AAvWF;AAyWE;EACE,iBAAA;EACA,kBAAA;AAvWJ;AA0WE;EACE,oCAAA;AAxWJ;;AA4WA;EACE,kBAAA;AAzWF;AA0WE;EACE,QAAA;EACA,aAAA;EACA,kBAAA;AAxWJ;;AA4WA;EACE,eAAA;EACA,cAAA;EACA,0BAAA;AAzWF","sourcesContent":["$width: 100%;\n\n.options {\n  display: flex;\n  border: 5px;\n  gap: 16px;\n}\n\n.FA {\n  width: 157px;\n  height: 32px;\n  padding-left: 24px;\n  font-weight: bold;\n}\n\n.Select-Supplier {\n  width: 130px;\n  height: 32px;\n}\n\n.date {\n  border-radius: 4px;\n\n  .p-inputtext {\n    border-radius: 4px;\n    height: 28px;\n  }\n\n  .p-button.p-button-icon-only {\n    height: 28px;\n    position: absolute;\n    right: 0;\n  }\n}\n\n// TabsComponent Styles End\n\n//ACP\n.acp {\n  .highlight-row {\n    background: #eef2ff !important;\n    color: #4338ca !important;\n    // background: #fff8ee !important;\n  }\n\n  .highlight-row-planning {\n    background: #e6f6e6 !important;\n    font-weight: bold;\n  }\n\n  .highlight-row-draft-planning {\n    background: #bbfabb !important;\n    font-weight: bold;\n  }\n\n  .invertedIcon {\n    transform: rotate(180deg);\n    transition: transform 0.5s;\n    cursor: pointer;\n  }\n\n  .nonInvertedIcon {\n    transition: 0.5s;\n    cursor: pointer;\n  }\n\n  .infoIcon,\n  .errorIcon {\n    cursor: pointer;\n  }\n\n  .acp-booking-table-dropdown {\n    display: flex;\n    gap: 16px;\n  }\n\n  .select-FA {\n    margin-left: 24px;\n    width: 90px;\n    height: 32px;\n  }\n\n  .select-supplier {\n    width: 130px;\n    height: 32px;\n    // font-size: 10px;\n  }\n\n  .content-layout .tabular-view .actions .action-buttons {\n    gap: 16px !important;\n  }\n\n  .acp-calendar {\n    width: 100px;\n\n    .p-inputtext {\n      border-radius: 4px;\n      height: 32px;\n\n      &:hover {\n        cursor: pointer;\n      }\n    }\n\n    // .p-button.p-button-icon-only {\n    //   color: #adadad !important;\n    //   background: #fff;\n    //   border-radius: 6px;\n    //   height: 30px;\n    //   border: 0;\n    //   position: absolute;\n    //   right: 1px;\n    //   top: 1px;\n    // }\n  }\n\n  .acp-booking-table {\n    margin-bottom: 50px;\n\n    .p-datatable {\n      padding: 5px 10px;\n    }\n    .p-datatable > .p-datatable-wrapper {\n      overflow: scroll !important;\n      width: 100% !important;\n      // height: calc(100vh - 290px) !important;//1024 resolution\n      // height: calc(100vh - 225px) !important;\n      height: calc(100vh - 30.5vh) !important;\n\n      table {\n        tbody {\n          tr {\n            td {\n              div {\n                display: flex;\n                justify-content: center;\n              }\n            }\n          }\n\n          tr.p-rowgroup-header {\n            td {\n              div {\n                display: flex;\n                justify-content: start;\n              }\n            }\n          }\n        }\n\n        // thead {\n        //   tr {\n        //     th {\n        //       div {\n        //         text-align: center;\n\n        //         // span {\n        //         //   div {\n        //         //     div {\n        //         //       padding-left: 8px;\n        //         //     }\n        //         //   }\n        //         // }\n        //       }\n        //     }\n        //   }\n        // }\n      }\n    }\n\n    .p-datatable-scrollable-table > .p-datatable-tbody > .p-rowgroup-header {\n      z-index: 70;\n      position: sticky;\n      background: #f2f7fc;\n      border-top: 3px solid white;\n      color: var(--Primary-color, #003da5);\n    }\n\n    .start-date-awaiting {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding-left: 10px;\n      font-weight: 900;\n      // color: blue;\n    }\n\n    .image-info-icon {\n      padding-left: 3.5%;\n    }\n  }\n\n  .text-massUpdate {\n    color: #003da5;\n    font-weight: bold;\n    padding: 8px 20px 8px 20px;\n\n    &:hover {\n      color: #003da5;\n      background: #f2f7fc !important;\n      padding: 8px 20px 8px 20px;\n      border-radius: 5px;\n    }\n  }\n\n  .acp-actions {\n    padding: 8px 12px 0 0px;\n\n    .action-buttons {\n      .dropdown-button-custom.show.dropdown {\n        .dropdown-menu.show {\n          padding: 0;\n\n          a.dropdown-item {\n            font-size: 12px;\n            color: #003da5;\n            font-weight: bold;\n            padding: 8px 20px;\n\n            &.disabled {\n              color: #7e8797 !important;\n            }\n\n            &:hover {\n              border-radius: 0 0 0 0;\n              background: #f2f7fc !important;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .acp-footer {\n    padding: 8px 10px 15px 10px !important;\n    background: #fafafa !important;\n    // bottom: 70px !important;//1024 resolution\n    bottom: 0.5rem !important;\n    position: sticky;\n    width: 100%;\n    margin: 0 auto;\n    z-index: 999;\n    left: 7.95%;\n    border-bottom-left-radius: 20px;\n    border-bottom-right-radius: 20px;\n  }\n}\n\n.acp-dialog {\n  width: 55vw !important;\n  min-height: 20%;\n  max-height: 90%;\n  border-radius: 20px;\n\n  .p-dialog .p-dialog-header {\n    border-top-right-radius: 6px;\n    border-top-left-radius: 6px;\n  }\n\n  .p-dialog .p-dialog-header-icons {\n    padding-bottom: 5px;\n  }\n\n  .p-dialog-acp {\n    color: #003da5;\n    font-size: 18px;\n    font-weight: 700;\n  }\n\n  .p-dialog-acp-error {\n    color: #c3133f;\n    font-size: 1.45rem;\n    font-weight: 700;\n  }\n\n  .p-dialog-content {\n    padding: 20px 32px 20px 32px !important;\n    border-radius: 0 0 20px 20px;\n    overflow-y: hidden;\n  }\n}\n\n.tooltipACP {\n  color: rgba(254, 254, 254, 1);\n  border-color: #007bff;\n  margin: 23px 0 0 -5.5px;\n\n  .tooltip-inner {\n    background-color: rgba(254, 254, 254, 1) !important;\n    max-width: 381px;\n    min-height: 30px;\n    border-radius: 2px;\n    border: solid 1px rgba(172, 172, 172, 1);\n    overflow-y: auto;\n    padding: 11px 16px 11px 14px;\n    box-shadow: 0px 6px 16px 0px rgba(89, 89, 89, 0.24);\n    margin-top: -40px;\n  }\n}\n\n.toolnameACP {\n  color: rgba(89, 89, 89, 1);\n  font-family: \"Montserrat\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 10px;\n  text-align: left;\n  // background: transparent;\n  line-height: 13px;\n\n  ul {\n    padding-left: 13px;\n    margin-bottom: 0px;\n  }\n}\n\n.tooltipACP > .tooltip-arrow {\n  top: -8px !important;\n}\n\n.tooltipACP > .tooltip-arrow::before {\n  border: 1px solid rgb(172, 172, 172);\n  width: 12px;\n  height: 12px;\n  border-right-color: transparent !important;\n  border-top-color: transparent !important;\n  transform: rotate(45deg);\n  right: -9px;\n  background-color: #fff;\n  top: -24px;\n}\n\n.navigationButtonWrapper,\n.navigationButton {\n  width: 100%;\n  background: #f2f7fc;\n  height: 28px;\n  border: 0;\n  display: flex;\n  align-items: center;\n}\n\n.navigationButton {\n  width: 76px;\n  text-decoration: none;\n}\n\n.navigationText {\n  margin-bottom: 0;\n  color: #595959;\n  font-size: 10px;\n  font-weight: 500;\n  font-family: \"Montserrat\";\n  font-style: normal;\n}\n\n// .calendar-icon {\n//   background-image: url(\"../../assets/images/acpCalenderIcon.svg\") !important;\n// }\n\n// .calendar-icon-white {\n//   img {\n//     filter: invert(100%) sepia(100%) saturate(10000%) hue-rotate(180deg);\n//   }\n// }\n\n.tableHeader {\n  color: #595959;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 15px;\n  font-family: \"Montserrat\";\n  font-style: normal;\n}\n\n.tableSubHeader {\n  color: #595959;\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  font-family: \"Montserrat\";\n}\n\n.dataTableWrapper {\n  margin: 24px 7.5% 24px 7.5%;\n  border-radius: 4px;\n  border: 1px solid #acacac;\n  width: 935px;\n\n  table thead {\n    height: 39px !important;\n  }\n\n  tbody tr {\n    height: 31px;\n  }\n\n  .p-datatable .p-datatable-tbody > tr > td {\n    text-align: center;\n    padding: 0;\n  }\n\n  // .p-datatable .p-column-header-content {\n  //   height: 15px;\n  // }\n\n  .columnDataText {\n    padding: 8px !important;\n    border: 1px solid #acacac !important;\n  }\n\n  .negativeValue {\n    background: #ffd8d8 !important;\n  }\n}\n\n// .selected .p-inputtext,\n// .selected .p-button.p-button-icon-only {\n//   background: #003da5 !important;\n//   color: #fff !important;\n// }\n\n.p-datepicker:not(.p-datepicker-inline) .p-datepicker-header,\n.p-datepicker table td.p-datepicker-today > span.p-highlight {\n  background: #003da5;\n}\n\n.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year,\n.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month,\n.p-datepicker .p-datepicker-header .p-datepicker-prev,\n.p-datepicker .p-datepicker-header .p-datepicker-next,\n.p-datepicker table td.p-datepicker-today > span.p-highlight {\n  color: #ffffff;\n  font-family: \"Montserrat\";\n}\n\n.p-datepicker {\n  width: 280px !important;\n}\n\n.p-datepicker .p-monthpicker .p-monthpicker-month.p-highlight {\n  background: #003da5;\n  color: #ffffff;\n}\n\n.p-datepicker {\n  margin-top: 5px;\n}\n\n.weekRangeDataWraper {\n  display: flex;\n  height: 81px;\n  flex-wrap: wrap;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.weekRangeData {\n  flex-direction: row;\n  width: 91px;\n  height: 19px;\n\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n.current-date {\n  margin-bottom: 0 !important;\n}\n\n.dataTableWrapper {\n  .tableSubHeader {\n    width: 130px !important;\n  }\n\n  .p-datatable .p-datatable-thead > tr > th {\n    width: 120px !important;\n  }\n}\n\n.acp-planning-page {\n  //height: 100%;\n  // overflow: scroll;\n  .p-datatable .p-column-header-content:nth-child(1) {\n    justify-content: center;\n  }\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.projectSetupParent {\n  flex: 1;\n}\n\n.error-info-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-left: 5%;\n}\n\n.headerWrapper {\n  padding: 0.1rem 1rem;\n  margin-top: 5px;\n}\n.acp-header .actions {\n    margin-right: 5px;\n}\n.acp-header img.header-icons {\n    margin-right: 10px;\n}\n.breadCrumbParent {\n    padding-left: 0px !important;\n}\n.breadCrumbParent .dropdown-menu.show {\n  padding-top: 0px;\n  padding-bottom: 0px;\n  margin-top: 0px !important;\n  border-radius: 5px;\n  border: 0.5px solid #b1b2b4 !important;\n}\n\n.navigationButtonWrapper {\n  padding-left: 2%;\n\n  .navigationButton {\n    justify-content: center;\n  }\n\n  .rccpText {\n    color: #003da5;\n  }\n\n  .activeSection {\n    color: #003da5;\n    font-weight: 500;\n    border-bottom: 1px solid var(--Primary-Color, #003da5);\n\n    .navigationText {\n      color: #003da5;\n    }\n  }\n}\n\n// ACP Booking\n.selection-main {\n  position: absolute;\n  left: 19%;\n  top: 6%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.selection-cont {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  padding: 0.8rem;\n}\n\n.selection-cont button {\n  background: #efefef;\n  border: none;\n  padding: 0.5rem;\n  border-radius: 0.3rem;\n  background: rgb(0, 61, 165) !important;\n  color: #fff;\n}\n\n.selection-cont i {\n  position: relative !important;\n  inset: 0 !important;\n  margin-right: 6px;\n}\n\n.ranges-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.8rem;\n}\n\n.ranges-btn button {\n  width: 30px;\n  background: #efefef;\n  border-radius: 4px;\n  margin-right: 5px;\n  padding: 6px;\n  border: none;\n  color: #003da5;\n}\n\n.capacity-main {\n  position: relative;\n}\n\n.acp-main .col {\n  display: flex;\n}\n\n.time-period-btn {\n  width: 30px;\n  background: rgb(239, 239, 239);\n  border-radius: 4px;\n  margin-right: 5px;\n  padding: 5px;\n  color: rgb(0, 61, 165);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.time-period-btn.selected {\n  background-color: rgb(0, 61, 165) !important;\n  color: #fff !important;\n}\n\n.booking-tabs {\n  overflow: auto !important;\n  padding-bottom: 0px !important;\n}\n\n.booking-header {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  padding: 8px 12px 0 0px;\n  align-items: center;\n}\n\n.data-table-checkbox-column {\n  div {\n    table {\n      thead,\n      tbody {\n        tr {\n          th:nth-child(1),\n          td:nth-child(1) {\n            width: 50px !important;\n            min-width: 50px !important;\n\n            div {\n              justify-content: center;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.acpBooking {\n  .flex-display {\n    display: flex;\n  }\n\n  div {\n    table {\n      margin-bottom: 80px;\n\n      // thead,\n      // tbody {\n      //   tr {\n\n      //     th:nth-child(1),\n      //     td:nth-child(1) {\n      //       width: 50px !important;\n      //       min-width: 50px !important;\n\n      //       div {\n      //         justify-content: center;\n      //       }\n      //     }\n      //   }\n      // }\n\n      // th .p-column-header-content:nth-child(1) {\n      //   justify-content: center;\n      // }\n\n      th.p-filter-column.p-frozen-column {\n        &:nth-child(1) {\n          max-width: 34px !important;\n\n          div.p-column-filter.p-fluid.p-column-filter-row {\n            visibility: hidden;\n            max-width: 34px !important;\n\n            div.p-fluid.p-column-filter-element {\n              .p-column-filter.p-inputtext.p-component {\n                text-align: center !important;\n              }\n            }\n          }\n        }\n      }\n\n      th.p-filter-column {\n        div.p-column-filter.p-fluid.p-column-filter-row {\n          div.p-fluid.p-column-filter-element {\n            .p-column-filter.p-inputtext.p-component {\n              text-align: center !important;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  tbody {\n    top: 0;\n    position: sticky;\n\n    tr {\n      &:nth-last-child(2) {\n        td {\n          border-bottom-width: 1.4px !important;\n        }\n      }\n\n      &.p-rowgroup-header {\n        top: 36px;\n        z-index: 111 !important;\n        position: sticky !important;\n        text-align: left !important;\n        background: #e1edff !important;\n\n        td {\n          left: 0px;\n          border: 0;\n          z-index: 2;\n          //width: 41.3%;\n          position: sticky;\n          text-align: left;\n          text-overflow: ellipsis;\n\n          &:nth-child(1) {\n            z-index: 20;\n          }\n\n          .p-rowgroup-header-name {\n            min-width: 85%;\n            cursor: pointer;\n            min-height: 20px;\n            padding-left: 20px;\n\n            .group-wrapper {\n              bottom: 10px;\n              position: relative;\n\n              .group-header {\n                padding-left: 5px;\n\n                span {\n                  font-size: 14px;\n                  color: #003da5;\n                  font-weight: bold;\n                }\n\n                .group-length {\n                  margin-left: 6px;\n                }\n\n                .p-link {\n                  margin-left: 4px;\n                }\n              }\n            }\n          }\n\n          .p-row-toggler.p-link {\n            height: 0;\n            visibility: hidden !important;\n          }\n        }\n\n        // &:has(.top-1) {\n        //   top: 42px !important;\n        // }\n\n        // &:has(.top-2) {\n        //   top: 90px !important;\n        // }\n\n        // &:has(.top-3) {\n        //   top: 138px !important;\n        // }\n\n        // &:has(.top-4) {\n        //   top: 186px !important;\n        // }\n\n        &:has(.top-5) {\n          top: 225px !important;\n        }\n\n        &:has(.top-6) {\n          top: 275px !important;\n        }\n      }\n    }\n\n    tr {\n      td {\n        text-align: center;\n      }\n    }\n  }\n}\n\n// #planning{\n//   .myProjectAnddAllProjectList .p-datatable > .p-datatable-wrapper{\n//     height: calc(100vh - 38.8vh) !important;\n//     overflow: auto;\n//   }\n// }\n// .acp-planning-table {\n//   .p-datatable > .p-datatable-wrapper {\n//     overflow: scroll !important;\n//     width: 100% !important;\n//     // height: calc(100vh - 290px) !important;//1024 resolution\n//     // height: calc(100vh - 225px) !important;\n//     height: calc(100vh - 57vh) !important;\n//   }\n\n//   .p-datatable-scrollable-table > .p-datatable-tbody > .p-rowgroup-header {\n//     background: #f2f7fc;\n//     color: var(--Primary-color, #003da5);\n//     border-top: 3px solid white;\n//   }\n\n//   .start-date-awaiting {\n//     display: flex;\n//     justify-content: space-between;\n//     align-items: center;\n//     padding-left: 10px;\n//     font-weight: 900;\n//     // color: blue;\n//   }\n// }\n\n.text-danger {\n  color: red;\n}\n\n.summary-table {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: auto !important;\n\n  .p-datatable {\n    width: 100%;\n  }\n\n  th span,\n  td {\n    font-size: 12px;\n  }\n\n  .negativeValue {\n    font-weight: bold;\n  }\n}\n\n//ACP Dashboard\n\n#dashboard {\n  div {\n    .capacity-main {\n      .acp-main {\n        min-height: 438px;\n\n        div {\n          .dashboard-panel-wrapper {\n            margin-top: 20px;\n            margin-bottom: 20px;\n\n            .acp-booking-table {\n              margin-top: 0px;\n              margin-bottom: 0px;\n\n              &:has(.panel2) {\n                margin-top: 0px;\n                margin-bottom: 60px;\n              }\n\n              .panel1.p-panel.p-component.p-panel-toggleable {\n                margin-bottom: 10px;\n\n                .p-panel-header {\n                  color: #003da5;\n                  background-color: #edf4fa;\n                }\n\n                .p-toggleable-content {\n                  .p-panel-content {\n                    .acpBooking {\n                      .p-datatable-wrapper {\n                        height: 40vh !important;\n\n                        table {\n                          margin-bottom: 20px;\n\n                          thead {\n                            tr {\n                              th.p-filter-column.p-frozen-column {\n                                &:nth-child(1) {\n                                  max-width: 53px !important;\n\n                                  div.p-column-filter.p-fluid.p-column-filter-row {\n                                    visibility: hidden;\n                                  }\n                                }\n                              }\n\n                              th .p-column-header-content:nth-child(1) {\n                                justify-content: center;\n                              }\n\n                              th.p-filter-column {\n                                div.p-column-filter.p-fluid.p-column-filter-row {\n                                  div.p-fluid.p-column-filter-element {\n                                    .p-column-filter.p-inputtext.p-component {\n                                      text-align: center !important;\n                                    }\n                                  }\n                                }\n                              }\n                            }\n                          }\n\n                          tbody {\n                            tr {\n                              td {\n                                border-width: 1px 1px 1px 1px;\n                              }\n\n                              &.p-datatable-row-expansion {\n                                td {\n                                  border-width: 0;\n                                  padding: 0rem 0rem;\n                                }\n                              }\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n\n              .panel2.p-panel.p-component.p-panel-toggleable {\n                margin-bottom: 10px;\n\n                .p-panel-header {\n                  color: #003da5;\n                  background-color: #edf4fa;\n                }\n\n                .p-toggleable-content {\n                  .p-panel-content {\n                    .acpBooking {\n                      .p-datatable-wrapper {\n                        height: 50.5vh !important;\n\n                        table {\n                          margin-bottom: 40px;\n\n                          thead {\n                            tr {\n                              th.p-filter-column.p-frozen-column {\n                                &:nth-child(1) {\n                                  max-width: 40px !important;\n\n                                  div.p-column-filter.p-fluid.p-column-filter-row {\n                                    visibility: hidden;\n                                    max-width: 40px !important;\n                                  }\n                                }\n                              }\n\n                              th.p-filter-column {\n                                div.p-column-filter.p-fluid.p-column-filter-row {\n                                  div.p-fluid.p-column-filter-element {\n                                    .p-column-filter.p-inputtext.p-component {\n                                      text-align: center !important;\n                                    }\n                                  }\n                                }\n                              }\n                            }\n                          }\n\n                          tbody {\n                            tr {\n                              &.p-rowgroup-header {\n                                top: 39px;\n                                border-top: 0;\n                                z-index: 111 !important;\n                                position: sticky !important;\n                                text-align: left !important;\n                                background: #e1edff !important;\n                                border-left: 1px solid #aba8a8;\n\n                                td {\n                                  left: 0px;\n                                  border: 0;\n                                  z-index: 2;\n                                  width: 41.3%;\n                                  position: sticky;\n                                  text-align: left;\n                                  text-overflow: ellipsis;\n\n                                  &:nth-child(1) {\n                                    z-index: 20;\n                                  }\n\n                                  .p-rowgroup-header-name {\n                                    min-width: 85%;\n                                    cursor: pointer;\n                                    min-height: 20px;\n                                    padding-left: 20px;\n\n                                    .group-wrapper {\n                                      bottom: 10px;\n                                      position: relative;\n\n                                      .group-header {\n                                        padding-left: 5px;\n\n                                        span {\n                                          font-size: 14px;\n                                          color: #003da5;\n                                          font-weight: bold;\n                                        }\n\n                                        .group-length {\n                                          margin-left: 6px;\n                                        }\n\n                                        .p-link {\n                                          margin-left: 4px;\n                                        }\n                                      }\n                                    }\n                                  }\n\n                                  .p-row-toggler.p-link {\n                                    height: 0;\n                                    visibility: hidden !important;\n                                  }\n                                }\n\n                                // &:has(.top-1) {\n                                //   top: 42px !important;\n                                // }\n\n                                // &:has(.top-2) {\n                                //   top: 91px !important;\n                                // }\n\n                                // &:has(.top-3) {\n                                //   top: 141px !important;\n                                // }\n\n                                // &:has(.top-4) {\n                                //   top: 190px !important;\n                                // }\n\n                                // &:has(.top-5) {\n                                //   top: 222px !important;\n                                // }\n\n                                // &:has(.top-6) {\n                                //   top: 275px !important;\n                                // }\n                              }\n\n                              td {\n                                border-width: 1px 1px 1px 1px;\n                              }\n\n                              &.p-datatable-row-expansion {\n                                td {\n                                  border-width: 0;\n                                }\n                              }\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.dashboard-container {\n  display: flex;\n\n  .autocomplete-container {\n    margin-left: 20px;\n    margin-right: 10px;\n  }\n\n  .p-autocomplete {\n    border: 1px solid #003da5 !important;\n  }\n}\n\n.clear-search-wrapper {\n  position: relative;\n  .clear-search-btn {\n    right: 0;\n    bottom: -12px;\n    position: absolute;\n  }\n}\n\n.task-link{\n  cursor: pointer;\n  color: #0a58ca;\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
